<div class="image-wrapper">
	<ng-container *ngIf="!(this.image.loading.value$ | async); else skeleton">
		<ng-container *ngIf="this.image.state.value$ | async as imageSrcData; else defaultAvatar">
			<img
				[src]="imageSrcData"
				alt="user-avatar"
				class="image-inner"
			>
		</ng-container>
		<ng-template #defaultAvatar>
			<ng-container *ngIf="this.defaultImageTemplate as _template; else showDefaultImageSource">
				<ng-container
					*ngTemplateOutlet="_template; context: this.defaultImageTemplateData || {}"
				></ng-container>
			</ng-container>
			<ng-template #showDefaultImageSource>
				@if (this.defaultImageSource$ | async | safeUrl; as surl) {
				<img
					[src]="surl"
					alt="default-user-avatar"
					class="image-inner dark:invert-0 invert"
					sizes="(max-width: 768) 480px,
            (max-width: 1920px) 768px,
            1024px"
					srcset="
						/assets/img/default.png      480w,
						/assets/img/defaultx256.png  768w,
						/assets/img/defaultx512.png 1024w
					"
				>
				}
			</ng-template>
		</ng-template>
	</ng-container>
	<ng-template #skeleton>
		<div
			appearance="circle"
			class="loader-inner image-inner mat-skeleton mat-skeleton flex flex-grow flex-col"
		></div>
	</ng-template>
</div>
